module.exports = __webpack_public_path__ + "assets/styles/font/Muli-Bold.ttf";